import { companyLocationService } from '../../helpers/services/companyLocation.service';
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const COMPANY_LOCATION_MODULE = 'companyLocation';

// define action 
export const GET_ALL_LOCATIONS = 'getAllLocations';
export const GET_LOCATION = 'getLocation';
export const UPDATE_LOCATION = 'updateLocation';
export const CREATE_LOCATION = 'createLocation';
export const UPDATE_LOCATION_STATUS = 'updateLocationStatus';
export const UPDATE_LOCATION_GEOMERTY = 'updateLocationGeometry';
export const UPDATE_LOCATION_DISABLE_PACKAGE_SERVICE = 'updateLocationDisablePackageService';
export const GET_ALL_LOCATIONS_PUBLIC = 'getAllLocationsPublic';
export const GET_LOCATION_PUBLIC = 'getLocationPublic';

// define mutation
const SUCCESS = "commonSuccess";
const SUCCESS_WITHOUT_REDIRECT = "successWithoutRedirect";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_LOCATIONS_REQUEST = "getAllLocation";
const GET_LOCATION_REQUEST = "getLocation";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_LOCATIONS]({ commit }, { filter }) {
        await companyLocationService
            .getAllLocations(filter)
            .then(
                (result) => {
                    commit(GET_ALL_LOCATIONS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_LOCATION]({ commit }, { id }) {
       await companyLocationService
            .getLocation(id)
            .then(
                (result) => {
                    commit(GET_LOCATION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_LOCATION]({ commit }, { data }) {
        commit(REQUEST)
        companyLocationService
            .updateLocation(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.companyLocation')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_LOCATION]: async ({ commit }, { redirect, data }) => {
        commit(REQUEST);
        var return_result = [];
        try {
            var result = await companyLocationService.createLocation(data);
            return_result['location_uuid'] = result.data.uuid;
            const message = i18n.t("message.createXSuccess", [i18n.t('module.companyLocation')]);
            sharedHelper.alertSuccessMessage(message);

            if (redirect) {
                commit(SUCCESS);
            } else {
                commit(SUCCESS_WITHOUT_REDIRECT);
            }

            return_result['result'] = true

        } catch (error) {
            const message = sharedHelper.getErrorMessage(error);
            sharedHelper.alertErrorMessage(message, error.response?.data?.code);
            commit(FAILURE);
            return_result['result'] = false
        }

        return return_result;

    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_LOCATION_STATUS]({ dispatch }, { filter, data }) {
        companyLocationService
            .updateLocationStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_LOCATIONS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_LOCATION_GEOMERTY]({ commit }, { data }) {
        commit(REQUEST)
        companyLocationService
            .updateLocationGeomerty(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.companyLocation')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    [UPDATE_LOCATION_DISABLE_PACKAGE_SERVICE]({ commit }, { data }) {
        commit(REQUEST)
        companyLocationService
            .updateLocationDisablePackageService(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.companyLocation')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    async [GET_ALL_LOCATIONS_PUBLIC]({ commit }, { filter }) {
        await companyLocationService
            .getAllLocationsPublic(filter)
            .then(
                (result) => {
                    commit(GET_ALL_LOCATIONS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_LOCATION_PUBLIC]({ commit }, { id }) {
       await companyLocationService
            .getLocationPublic(id)
            .then(
                (result) => {
                    commit(GET_LOCATION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Company-location-listing" });
    },
    [SUCCESS_WITHOUT_REDIRECT](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_LOCATIONS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                phoneCode: o.phone_code,
                phone: o.phone,
                phoneISO: o.phone_iso,
                email: o.email,
                name: o.name,
                isActive: o.is_active,
                isAllowAppointment: o.is_allow_appointment,
                isHQ: o.is_hq,
                company: o.company,
                companyType: o.company_type,
                location: o.location,
                currentClosePeriod: o.current_close_periods,
                closePeriod: o.close_periods,
                companyStaff: o.company_staffs,
                address1: o.address_1,
                address2: o.address_2,
                address3: o.address_3,
                postcode: o.postcode,
                city: o.city,
                state: o.state,
                mapURL: o.map_url,
                latitude: o.latitude,
                longitude: o.longitude,
                disableServiceID: o.disable_service_id,
                disablePackageID: o.disable_package_id,
                logoURL: o.logo_url,
                companyTypeNames: o.company_type ? o.company_type.map((type) => `${type.name}`).join(',') : '',
            }
        })
    },
    [GET_LOCATION_REQUEST](state, data) {
        let o = data.data
                
        state.details = {
            uuid: o.uuid,
            phoneCode: o.phone_code,
            phone: o.phone,
            phoneISO: o.phone_iso,
            email: o.email,
            isAllowAppointment: o.is_allow_appointment,
            name: o.name,
            isActive: o.is_active,
            isHQ: o.is_hq,
            company: o.company,
            companyType: o.company_type.map((type) => {
                return {
                    value: type.uuid,
                    text: type.name
                }
            }),
            location: o.location,
            currentClosePeriod: o.current_close_periods,
            closePeriod: o.close_periods,
            companyStaff: o.company_staffs,
            address1: o.address_1,
            address2: o.address_2,
            address3: o.address_3,
            postcode: o.postcode,
            city: o.city,
            state: o.state,
            mapURL: o.map_url,
            latitude: o.latitude,
            longitude: o.longitude,
            logoURL: o.logo_url,
            disableServiceID: o.disable_service_id != null ? JSON.parse(o.disable_service_id) : [],
            disablePackageID: o.disable_package_id != null ? JSON.parse(o.disable_package_id) : [],
            companyTypeIDs: o.company_type.map((type) => `${type.uuid}`),
            locationID: o.location != null ? {
                value: o.location.uuid,
                text: o.location.location
            } : '',
            companyID: o.company != null ? {
                value: o.company.uuid,
                text: o.company.name
            } : '',
        }
    }
}


